import * as React from 'react';
import './monthlyGoalCard.module.scss';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { inject, observer } from 'mobx-react';
import { ComponentType } from 'react';
import { HomePageState } from '../../../../containers/home/states/HomePageState';
import { Button } from '@sheinc/shelikes-design-system';

type Props = {
  loading?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDetailClick?: () => any;
};

const _MonthlyGoalCard = inject('homeState')(
  observer(
    class _MonthlyGoalCard extends React.Component<Props & { homeState: HomePageState }> {
      render() {
        const { loading, onDetailClick, homeState } = this.props;
        const { monthlyGoalSummary } = homeState.monthlyGoals;
        if (monthlyGoalSummary.loading || monthlyGoalSummary.isEmpty()) {
          return null;
        }
        const monthlyGoal = monthlyGoalSummary.getOrThrow();
        return (
          <div styleName="card">
            <div styleName="header">今月の目標</div>
            <div styleName="inner">
              {monthlyGoal.goal ? (
                <div styleName="goal-text">{monthlyGoal.goal}</div>
              ) : (
                <div styleName="goal-placeholder">今月の目標を設定しましょう</div>
              )}
              <Button variant="secondary" size="small" chevron="right" onClick={onDetailClick} isLoading={loading}>
                {GlobalStatesV3.viewport.isNonSp ? '目標の詳細へ' : '目標をみる'}
              </Button>
            </div>
          </div>
        );
      }
    }
  )
);

export const MonthlyGoalCard = _MonthlyGoalCard as ComponentType<Props>;
